import { useContext, useEffect } from 'react';
import styled from 'styled-components';
import { RegisterContext } from '../../context/register.context';
import { useMutation } from 'react-query';
import SynthiAiSumImgage from './images/synthi_summary.png';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import {
	createOneOffPayment,
	createSubscriptionPayment,
} from '@/api/query/payment';
import { MessageContext } from '@/common/contexts/message-context/MessageContext';
import { LanguageContext } from '@/common/contexts/LanguageContext';
import { PAYMENT_OPERATORS } from '@/common/constants/paymentOperators';
import { APPLICATION_PAYWALL_UTMS } from '@/common/constants/application.utms';
import Loading from '@/common/components/Loading';

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 75vw;
	background: #fff;
	padding: 10px 30px;

	border-radius: 10px;

	@media (min-width: 600px) {
		display: none;
	}
`;
const Title = styled.h3`
	color: #05275d;

	text-align: center;
	font-family: Work Sans;
	font-size: 28px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	letter-spacing: -0.56px;
	margin: 0;

	@media (max-width: 600px) {
		display: none;
	}
`;

const SubTitle = styled.p`
	color: #05275d;
	text-align: center;
	font-family: 'Work Sans';
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	margin: 0;

	@media (min-width: 600px) {
		text-align: left;
		color: #05275d;
		font-family: 'Work Sans';
		font-size: 16px;
		font-style: normal;
		font-weight: 500;
		line-height: normal;
	}
`;

const Price = styled.p`
	color: #05275d;
	font-family: 'Work Sans';
	font-size: 20px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	letter-spacing: -0.4px;
`;

const Pacakge = styled.div`
	display: flex;
	padding: 10px;
	gap: 20px;

	@media (min-width: 600px) {
		padding: 10px 0px 20px 0;
	}
`;

const SubPacakge = styled.p`
	color: #05275d;

	text-align: center;
	font-family: Work Sans;
	font-size: 20px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	margin: 0;
	width: 100%;
	text-align: left;
`;

const ImgeWrapper = styled.img`
	max-width: 40px;
`;

const DataText = styled.p`
	color: #05275d;
	text-align: center;
	font-family: 'Work Sans';
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	text-align: left;
	width: 100%;
	margin: 0;
`;

const Border = styled.div`
	height: 1px;
	width: 100%;
	margin-top: 10px;
	background: #d9d9d9;
`;

const ImageWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 20px;

	border-radius: 5px;
	border: 1px solid rgba(79, 167, 180, 0.2);
	background: #fff;
	padding: 5px;
`;

const ActionWrapper = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
	gap: 10px;
	margin: 0px 0;

	@media (max-width: 600px) {
		flex-wrap: wrap;
	}
`;

const LetMailButton = styled.button`
	display: inline-flex;
	padding: 9px 82px 10px 82px;
	justify-content: center;
	align-items: center;
	cursor: pointer;

	color: #fff;
	text-align: center;
	font-family: 'Work Sans';
	font-size: 20px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	letter-spacing: 0.8px;
	text-transform: uppercase;
	background: linear-gradient(10deg, #48068a 10%, #4322c6 65%);
`;

const PayuLink = styled.a`
	color: #05275d;
`;

const TitleMobile = styled.div`
	color: #05275d;
	text-align: center;
	font-family: 'Work Sans';
	font-size: 22px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	letter-spacing: -0.56px;
	display: none;
	margin: 20px 0;

	@media (min-width: 600px) {
		color: #29185e;
		text-align: center;
		font-family: 'Work Sans';
		font-size: 28px;
		font-style: normal;
		font-weight: 700;
		line-height: normal;
		display: flex;
		justify-content: center;
	}
`;
const TopPlanData = styled.div`
	color: #05275d;
	font-family: 'Work Sans';
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	margin-bottom: 5px;
`;

const BottomPlanData = styled.div`
	color: #05275d;
	font-family: 'Work Sans';
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
`;

const LinkWrapper = styled.div`
	color: #05275d;
	text-align: center;
	font-family: 'Work Sans';
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;

	/* Hide the default checkbox */
	input[type='checkbox'] {
		appearance: none;
		-webkit-appearance: none;
		-moz-appearance: none;
		width: 15px;
		height: 15px;
		border: 2px solid #29185e;
		border-radius: 4px;
		outline: none;
		cursor: pointer;
		position: relative;
		display: inline-block;
		vertical-align: middle;
	}

	/* Style the checkbox when checked */
	input[type='checkbox']:checked {
		background-color: #29185e;
	}

	/* Create the checkmark using a pseudo-element */
	input[type='checkbox']:checked::before {
		content: '';
		position: absolute;
		top: 50%;
		left: 50%;
		width: 4px;
		height: 8px;
		border: solid white;
		border-width: 0 2px 2px 0;
		transform: translate(-50%, -50%) rotate(45deg);
	}

	input[type='checkbox']:focus {
		box-shadow: 0 0 3px #29185e;
	}
`;

const MainWrapperContent = styled.div`
	display: flex;
	flex-direction: column;

	@media (max-width: 600px) {
		height: calc(var(--vh, 1vh) * 100 - 100px);
	}
`;

const PaymentTitle = styled.p`
	color: #05275d;
	font-family: 'Work Sans';
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	letter-spacing: -0.32px;

	display: flex;
	justify-content: center;
	align-items: center;
	gap: 5px;
`;

const WrapperDesktop = styled.div`
	display: flex;
	gap: 40px;
	margin-bottom: 50px;

	@media (max-width: 600px) {
		display: none;
	}
`;

const Left = styled.div``;

const Right = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

const StyledSubmit = styled.button`
	background-color: #650675;
	color: #ffffff;
	border: none;
	border-radius: 10px;
	padding: 10px 20px;
	cursor: pointer;
	font-size: 16px;
	transition: background-color 0.3s ease;
	&:hover {
		background-color: #2980b9;
	}
	width: 100%;
	margin-top: 10px;
`;

const ContentWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 20px;
`;

const AditionalInfoSub = styled.div`
	color: #868686;
	font-family: 'Work Sans';
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	margin-bottom: 16px;
`;

const FastSpringView = () => {
	const data = useLanguageData('register.stepThree');
	const { user, plan } = useContext(RegisterContext);
	const { lang } = useContext(LanguageContext);

	const handleCreateOrder = async (data) => {
		setTimeout(() => {
			window.location.href = `https://${window.location.host}`;
		}, 2000);
	};

	const reloadFastSpring = () => {
		const old = document.getElementById('fsc-api');
		if (old) old.remove();

		const script = document.createElement('script');
		script.id = 'fsc-api';
		script.src =
			'https://sbl.onfastspring.com/sbl/1.0.5/fastspring-builder.min.js';
		script.type = 'text/javascript';
		script.dataset.storefront = 'synthi.onfastspring.com/embedded-br-pt';
		script.dataset.popupWebhookReceived = 'onCheckoutCompleted';

		document.body.appendChild(script);
	};

	const handleSetupPriceSum = async () => {
		const path = plan.fast_spring_product_path;
		reloadFastSpring();

		await window.fastspring.builder.tag({
			paymentUtms: JSON.stringify(APPLICATION_PAYWALL_UTMS),
			plan: plan._id,
			lang: lang,
			promo: false,
		});

		await window.fastspring.builder.push({
			products: [{ path, quantity: 1 }],
			country: 'BR',
			language: 'pt',
			paymentContact: {
				email: user.email,
			},
			checkout: true,
		});
	};

	useEffect(() => {
		if (!plan || window?.fastspring?.builder === undefined) return;
		handleSetupPriceSum();
	}, [plan, window?.fastspring]);

	useEffect(() => {
		if (!plan) return;

		window.onCheckoutCompleted = (data) => {
			handleCreateOrder(data);
		};
	}, [plan]);

	return (
		<div>
			<MainWrapperContent>
				<TitleMobile>{data.title}</TitleMobile>
				<ContentWrapper>
					<div
						id='fsc-embedded-checkout-container'
						style={{ position: 'relative', width: '50vw', zIndex: 100 }}
						autoFocus
					></div>
				</ContentWrapper>
				<ActionWrapper></ActionWrapper>
			</MainWrapperContent>
		</div>
	);
};

export default FastSpringView;
